<template>
    <ValidationObserver ref="observer" v-slot="{ handleSubmit }" slim>
        <form class="modal-card prd-modal-card" @submit.prevent="handleSubmit(salvar)">
            <b-loading :active="carregandoConfiguracao" :is-full-page="false" />
            <header class="modal-card-head">
                <div class="prd-modal-heading">
                    <span class="prd-modal-icon"><b-icon icon="cube-outline" /></span>
                    <div>
                        <p class="modal-card-title">{{ model.id ? 'Editar item' : 'Novo item' }}</p>
                        <p class="prd-modal-subtitle">Informe os dados comerciais e os detalhes necessários para a produção.</p>
                    </div>
                </div>
            </header>

            <section v-show="!carregandoConfiguracao" class="modal-card-body">
                <div class="prd-form-section">
                    <div class="prd-section-heading">
                        <div>
                            <p class="prd-section-title">Item e valores</p>
                            <p class="prd-section-description">Identifique a peça e defina as informações usadas no orçamento.</p>
                        </div>
                        <span class="prd-required-note">* Obrigatório</span>
                    </div>

                    <ValidationProvider v-slot="{ errors }" name="Descrição" rules="required">
                        <b-field label="Descrição da peça *" :type="errors.length ? 'is-danger' : null" :message="errors">
                            <b-input v-model.trim="model.descricao" maxlength="500" placeholder="Ex.: Painel ripado para recepção" :disabled="somenteValor" autofocus />
                        </b-field>
                    </ValidationProvider>

                    <div class="prd-field-grid prd-commercial-grid" :class="{ 'prd-commercial-grid-sem-unidade': !elementoVisivel('campo-unidade') }">
                        <div>
                            <ValidationProvider v-slot="{ errors }" name="Quantidade" rules="required|min_value:0.001">
                                <b-field label="Quantidade *" :type="errors.length ? 'is-danger' : null" :message="errors">
                                    <b-numberinput v-model="model.quantidade" :min="1" :step="1" controls-position="compact" :disabled="somenteValor" />
                                </b-field>
                            </ValidationProvider>
                        </div>
                        <div v-if="elementoVisivel('campo-unidade')">
                            <b-field id="campo-unidade" label="Unidade">
                                <b-select v-model="model.unidadeMedida" expanded :disabled="somenteValor">
                                    <option value="UN">Unidade</option>
                                    <option value="PC">Peça</option>
                                    <option value="KG">Quilograma</option>
                                    <option value="M">Metro</option>
                                    <option value="CJ">Conjunto</option>
                                </b-select>
                            </b-field>
                        </div>
                        <div>
                            <ValidationProvider v-slot="{ errors }" name="Valor unitário" rules="min_value:0">
                                <b-field label="Valor unitário comercial" :type="errors.length ? 'is-danger' : null" :message="errors">
                                    <div class="prd-money-input">
                                        <span class="prd-currency-prefix">R$</span>
                                        <b-numberinput
                                            v-model="model.valorUnitarioComercial"
                                            :min="0"
                                            :step="0.01"
                                            controls-position="compact"
                                        />
                                    </div>
                                </b-field>
                            </ValidationProvider>
                        </div>
                    </div>

                    <div class="prd-item-total">
                        <span>Subtotal do item</span>
                        <strong>{{ valorTotalFormatado }}</strong>
                    </div>
                </div>

                <div class="prd-form-section">
                    <div class="prd-section-heading">
                        <div>
                            <p class="prd-section-title">Especificações técnicas</p>
                            <p class="prd-section-description">Detalhes que ajudam a produção a avaliar e fabricar a peça corretamente.</p>
                        </div>
                    </div>

                    <div class="prd-field-grid">
                        <b-field label="Material">
                            <b-input v-model.trim="model.material" maxlength="200" placeholder="Ex.: MDF 18 mm" :disabled="somenteValor" />
                        </b-field>
                        <b-field label="Dimensões / medidas">
                            <b-input v-model.trim="model.dimensoes" maxlength="300" placeholder="Ex.: 1200 x 600 x 18 mm" :disabled="somenteValor" />
                        </b-field>
                        <b-field label="Acabamento">
                            <b-input v-model.trim="model.acabamento" maxlength="300" placeholder="Ex.: Laca fosca, cor branca" :disabled="somenteValor" />
                        </b-field>
                        <b-field class="prd-field-wide" label="Processo / especificação">
                            <b-input
                                v-model.trim="model.processo"
                                type="textarea"
                                rows="2"
                                maxlength="500"
                                :disabled="somenteValor"
                                placeholder="Descreva usinagem, montagem, ferragens ou outros requisitos técnicos."
                            />
                        </b-field>
                    </div>
                </div>

                <div class="prd-form-section prd-form-section-last">
                    <div class="prd-section-heading">
                        <div>
                            <p class="prd-section-title">Orientações complementares</p>
                            <p class="prd-section-description">
                                Use este espaço para cuidados, prioridades ou informações que não se encaixam nos campos acima.
                            </p>
                        </div>
                    </div>
                    <b-field label="Observações para a produção">
                        <b-input
                            v-model.trim="model.observacoesComercial"
                            type="textarea"
                            rows="3"
                            maxlength="2000"
                            :disabled="somenteValor"
                            placeholder="Inclua referências, tolerâncias ou pontos de atenção."
                        />
                    </b-field>
                </div>
            </section>

            <footer class="modal-card-foot prd-modal-actions">
                <span class="prd-footer-hint">Revise as especificações antes de salvar.</span>
                <div class="prd-footer-buttons">
                    <b-button native-type="button" @click="$emit('close')">Cancelar</b-button>
                    <b-button native-type="submit" type="is-primary" icon-left="check" :disabled="carregandoConfiguracao">Salvar item</b-button>
                </div>
            </footer>
        </form>
    </ValidationObserver>
</template>

<script>
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import { mapState } from 'vuex'
import http from '@/http'

export default {
    name: 'PrdOrcamentoItemModal',
    components: { ValidationObserver, ValidationProvider },
    props: {
        item: { type: Object, default: () => ({}) },
        somenteValor: { type: Boolean, default: false },
    },
    data() {
        const model = Object.assign(
            {
                id: 0,
                quantidade: 1,
                unidadeMedida: 'UN',
                descricao: '',
                material: '',
                dimensoes: '',
                processo: '',
                acabamento: '',
                observacoesComercial: '',
                valorUnitarioComercial: 0,
            },
            JSON.parse(JSON.stringify(this.item || {}))
        )
        if (model.valorUnitarioComercial == null) model.valorUnitarioComercial = 0
        return {
            model,
            configuracaoTela: {},
            carregandoConfiguracao: true,
        }
    },
    created() {
        this.carregarConfiguracaoTela()
    },
    watch: {
        unidadeId() {
            this.carregarConfiguracaoTela()
        },
    },
    computed: {
        ...mapState(['unidadeId']),
        valorTotalFormatado() {
            const quantidade = Number(this.model.quantidade) || 0
            const valorUnitario = Number(this.model.valorUnitarioComercial) || 0
            return (quantidade * valorUnitario).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
        },
    },
    methods: {
        carregarConfiguracaoTela() {
            this.configuracaoTela = {}
            const unidadeId = this.unidadeId
            if (!unidadeId) {
                this.carregandoConfiguracao = false
                return Promise.resolve()
            }
            this.carregandoConfiguracao = true
            return http.get('/api/prd/orcamentos/itens/configuracao-tela', { params: { unidadeId } })
                .then((response) => {
                    if (this.unidadeId !== unidadeId) return
                    const valor = response.data && response.data.valor
                    if (!valor) return
                    const configuracao = typeof valor === 'string' ? JSON.parse(valor) : valor
                    this.configuracaoTela = configuracao && typeof configuracao === 'object' && !Array.isArray(configuracao) ? configuracao : {}
                })
                .catch(() => {
                    if (this.unidadeId !== unidadeId) return
                    this.configuracaoTela = {}
                    this.$buefy.toast.open({
                        message: 'Não foi possível carregar a configuração da tela. Os campos serão exibidos.',
                        type: 'is-danger',
                    })
                })
                .finally(() => {
                    if (this.unidadeId === unidadeId) this.carregandoConfiguracao = false
                })
        },
        elementoVisivel(nome) {
            return this.configuracaoTela[nome] !== true
        },
        salvar() {
            if (this.carregandoConfiguracao) return
            this.$emit('salvar', this.model)
        },
    },
}
</script>

<style scoped>
.prd-modal-card {
    width: min(820px, calc(100vw - 2rem));
}
.modal-card-head {
    align-items: flex-start;
    padding: 1.25rem 1.5rem;
}
.prd-modal-heading {
    display: flex;
    align-items: center;
    gap: 0.85rem;
}
.prd-modal-icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 2.65rem;
    height: 2.65rem;
    flex: 0 0 2.65rem;
    border-radius: 10px;
    background: rgba(50, 115, 220, 0.1);
    color: #3273dc;
}
.modal-card-title {
    font-size: 1.2rem;
    font-weight: 700;
    line-height: 1.3;
}
.prd-modal-subtitle {
    margin-top: 0.2rem;
    color: #6b7280;
    font-size: 0.82rem;
    line-height: 1.4;
}
.modal-card-body {
    padding: 0;
    background: #f7f9fc;
}
.prd-form-section {
    padding: 1.35rem 1.5rem;
    border-bottom: 1px solid #e7ecf2;
    background: #fff;
}
.prd-form-section-last {
    border-bottom: 0;
}
.prd-section-heading {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 1rem;
    margin-bottom: 1rem;
}
.prd-section-title {
    color: #263445;
    font-size: 0.95rem;
    font-weight: 700;
}
.prd-section-description {
    margin-top: 0.15rem;
    color: #7a8594;
    font-size: 0.76rem;
    line-height: 1.4;
}
.prd-required-note {
    flex: none;
    color: #b45309;
    font-size: 0.7rem;
    font-weight: 600;
}
.prd-field-grid {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 0 1rem;
}
.prd-commercial-grid {
    grid-template-columns: minmax(150px, 0.75fr) minmax(150px, 0.75fr) minmax(250px, 1.5fr);
}
.prd-commercial-grid-sem-unidade {
    grid-template-columns: minmax(150px, 0.75fr) minmax(250px, 1.5fr);
}
.prd-field-wide {
    grid-column: 1 / -1;
}
.prd-item-total {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 0.15rem;
    padding: 0.7rem 0.85rem;
    border: 1px solid #dbe7f5;
    border-radius: 8px;
    background: #f3f7fc;
    color: #52606d;
    font-size: 0.8rem;
}
.prd-item-total strong {
    color: #1f5fbf;
    font-size: 1rem;
}
.prd-money-input {
    display: flex;
    align-items: stretch;
    width: 100%;
}
.prd-currency-prefix {
    display: inline-flex;
    align-items: center;
    padding: 0 0.75rem;
    border: 1px solid #dbdbdb;
    border-right: 0;
    border-radius: 4px 0 0 4px;
    background: #f5f5f5;
    color: #4a4a4a;
    font-weight: 600;
}
.prd-money-input ::v-deep .numberinput {
    flex: 1;
    min-width: 0;
}
.prd-modal-actions {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 1rem;
    padding: 1rem 1.5rem;
}
.prd-footer-hint {
    color: #7a8594;
    font-size: 0.75rem;
}
.prd-footer-buttons {
    display: flex;
    gap: 0.65rem;
}
@media (max-width: 768px) {
    .prd-modal-card {
        width: calc(100vw - 1rem);
    }
    .modal-card-head,
    .prd-form-section,
    .prd-modal-actions {
        padding-left: 1rem;
        padding-right: 1rem;
    }
    .prd-field-grid,
    .prd-commercial-grid,
    .prd-commercial-grid-sem-unidade {
        grid-template-columns: 1fr;
    }
    .prd-field-wide {
        grid-column: auto;
    }
    .prd-modal-actions {
        align-items: stretch;
        flex-direction: column;
    }
    .prd-footer-hint {
        display: none;
    }
    .prd-footer-buttons {
        display: grid;
        grid-template-columns: 1fr 1fr;
    }
    .prd-footer-buttons .button {
        width: 100%;
    }
}
</style>
